
export const convertStringBooleanAndClean = (val: any): any => {
  if (val === "Yes") return true;
  if (val === "No") return false;
  if (val === "" || val === undefined || val === null) return undefined;
  return val;
};
